import React,{useRef,useState} from 'react'
import {BrowserRouter as Router,Switch,Route} from 'react-router-dom';
import ASideBar from './ASideBar';
import AGestaVendas from './AGestaVendas';
import Geststs from './geststs';
import AGestPagamentos from './AGestPagamentos';
import AGestRelatorios from './AGestRelatorios';
import Profile from './Profile';
import '../Ahome.css';
import {Protegerotas} from './protegerotas';
import { useHistory } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import RMontante from './RMontante';
import RConsumo from './RConsumo';
import Rquantidade from './Rquantidade';
import ConsumoCliente from './consumocliente';
import GestaoEstatisc from './GestaoEstatisc';
import VolumeConsumido from './VolumeConsumido';
import Montanteadq from './Montanteadq';
import ConsumoExcessivo from './ConsumoExcessivo';
import ConsumoInadequado from './ConsumoInadequado';

import type { MenuProps } from 'antd';
import { Breadcrumb, Layout, Menu, theme } from 'antd';


import {
  PayCircleOutlined,
  ProfileOutlined,
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  StarOutlined,
  UserOutlined,
  HomeOutlined
} from '@ant-design/icons';
import SemConsumo from './SemConsumo';
import RelatorioVenda from './RelatorioVenda';

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    label,
    icon,
    children,
  };
}
function AHome() {
  const ileTimeRed=useRef(null)
  const [collapsed, setCollapsed] = useState(false);
  const history = useHistory();
  const [pagina,setPagina]=useState("home")
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleClick = (e) => {
    console.log('Clicked: ', e.key);
    if(e.key =="1"){
      setPagina("Gestao de Vendas")
        history.push("/admin/home/gestVendas")
       
    }
    if(e.key=="21"){
      setPagina("Gestão de Pagamentos")
      history.push("/admin/home/gestPagamento")

    }
    if(e.key=="31"){
      setPagina("Relatorios Estatisticos")
      history.push("/admin/home/Relatorios_estatisticos")

    }


    if(e.key=="32"){
      setPagina("Registo de servico")
      history.push("/admin/home/Relatorios_servico")

    }
    if(e.key=="3"){
      setPagina("Pesquisar Escola")
      history.push("/admin/home/Pesquisa_escola")

    }




  }

  const { Header, Content, Footer, Sider } = Layout;

type MenuItem = Required<MenuProps>['items'][number];

  const onIdle=()=>{
    localStorage.setItem('log',false)
    history.push('/');
  }


  const items: MenuItem[] = [
    getItem('Gestão de Vendas', '1', <DesktopOutlined />,  ),
    
    
    getItem('Gestão de Pagamentos', '21', <PieChartOutlined />),
    
    
 
   
    
    
    getItem('Gestão de Relatorios', 'sub3', <FileOutlined />, [
      getItem('Relatorios Estatisticos', '31'),
      getItem('Registo de servico', '32'),
      getItem('Relatorio de Venda', '3.3'),
     
      

    ]),
  
  ];

  return (

    


<Layout style={{ minHeight: '100vh' }}>
<Sider theme="light" collapsible collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
<img  className="enh-kogas-logo" src={require('./images/ENH.png')}  />
<div style={{ height: 32, margin: 16, background: 'rgba(255, 255, 255, 0.2)' }} />

  <Menu theme="light"   onClick={handleClick}  defaultSelectedKeys={['1']} mode="inline" items={items} />
</Sider>
<Layout>
  <Header style={{ padding: 0, background: colorBgContainer }} />
  <Content style={{overflow:'scroll',margin: '0 16px' }}>
    <Breadcrumb style={{ margin: '16px 0' }}>
      <Breadcrumb.Item>{localStorage.getItem('username')}</Breadcrumb.Item>
      <Breadcrumb.Item>{pagina}</Breadcrumb.Item>
    
    </Breadcrumb>
    <div style={{background: colorBgContainer }}>
     
   
    <IdleTimer ref={ileTimeRed} timeout={60*1000} onIdle={onIdle}></IdleTimer>
    <div className='Conteudo'>
      <Switch>
      <Protegerotas path="/admin/home/gestVendas" exact component={AGestaVendas}/>
      <Protegerotas path="/admin/home/gestPagamento" exact component={AGestPagamentos}/>      
      <Protegerotas path="/admin/home/gestRelatorios" exact component={AGestRelatorios}/>            
      <Protegerotas path="/admin/home/Relatorios_estatisticos" exact component={GestaoEstatisc}/>            
      <Protegerotas path="/admin/home/Relatorios_servico" exact component={RelatorioVenda}/>            
      <Protegerotas path="/admin/home/Relatorios_estatisticos/volconsumo" exact component={VolumeConsumido}/>
      <Protegerotas path="/admin/home/Relatorios_estatisticos/montconsumo" exact component={Montanteadq}/>
      <Protegerotas path="/admin/home/Relatorios_estatisticos/cosumocliente" exact component={ConsumoCliente}/>
      <Protegerotas path="/admin/home/Relatorios_estatisticos/consumoExcessivo" exact component={ConsumoExcessivo}/>
      <Protegerotas path="/admin/home/Relatorios_estatisticos/consumoInaquado" exact component={ConsumoInadequado}/>
      <Protegerotas path="/admin/home/Relatorios_estatisticos/consumoSem" exact component={SemConsumo}/>
      

      <Protegerotas path="/admin/home/consumo" exact component={RConsumo}/>            
      <Protegerotas path="/admin/home/montante" exact component={RMontante}/>            
      <Protegerotas path="/admin/home/quantidade" exact component={Rquantidade}/>      
      
      <Protegerotas path="/admin/home/totalcliente" exact component={ConsumoCliente}/>            
  
      <Protegerotas path="/admin/home/gestSTS" exact component={Geststs}/>
      <Protegerotas path="/admin/home/profile" exact component={Profile}/>

      </Switch>

    </div>
    
   
 
    
    </div>
  </Content>
 
</Layout>
</Layout>



   
  )
}

export default AHome